import * as t from 'io-ts';
import { CallResponseSchema } from "../common/callResponseSchema";
import { enumCodec } from '../../validation/validator';
import { MatchStatus } from '../../types/TrackingTypes';
import { ImportFormat } from '../../enums';

// TrackingProviderRecordSchema definition
export const TrackingProviderRecordSchema = t.type({
    id: t.number,
    name: t.string,
    data_format: enumCodec(ImportFormat),
    external_uid: t.string
});

export type TrackingProviderRecord = t.TypeOf<typeof TrackingProviderRecordSchema>;

// Request schemas
export const CallProxyRequest = t.type({
    url: t.string,
    method: t.string
});

export const CacheMatchesSchema = t.partial({
    tracking_provider_id: t.union([t.number, t.null, t.undefined]),
    from_date: t.union([t.number, t.null, t.undefined]),
    to_date: t.union([t.number, t.null, t.undefined])
});

export const GetMatchErrorsSchema = t.type({
    account_id: t.number,
    tracking_provider_id: t.number,
    match_id: t.string
});

export const GetClubMatchesSchema = t.intersection([
    t.type({
        account_id: t.number,
        tracking_provider_id: t.number,
    }), t.partial({
        from_date: t.number,
        to_date: t.number
    })
]);

export const GetScenarioDataSchema = t.intersection([
    t.type({
        account_id: t.number,
        tracking_provider_id: t.number,
        match_id: t.string,
        start_time: t.number,
        end_time: t.number,
    }), t.partial({
        player_id: t.string,
        scenario_data: t.union([t.unknown, t.null, t.undefined]),
        mirror_x: t.union([t.boolean, t.null, t.undefined]),
        mirror_y: t.union([t.boolean, t.null, t.undefined]),
        raw_data: t.union([t.boolean, t.null, t.undefined])
    })
]);

export type GetScenarioDataRequest = typeof GetScenarioDataSchema;
export type GetClubMatchesRequest = typeof GetClubMatchesSchema;

export const MatchSchema = t.intersection([
    t.type({
        match_id: t.string,
        match_date: t.string,
        home_team_id: t.string,
        home_team_name: t.string,
        away_team_id: t.string,
        away_team_name: t.string,
        home_team_score: t.number,
        away_team_score: t.number,
        competition_name: t.string,
        ruleset: t.string,
        description: t.string,
        venue: t.string,
        duration: t.number
    }),
    t.partial({
        status: enumCodec(MatchStatus)
    })
]);

export type Match = t.TypeOf<typeof MatchSchema>;

export const GetClubMatchesResponseSchema = t.type({
    data: t.array(MatchSchema)
});

export const TrackingApis = {
    Tracking: {
        CallProxy: {
            Name: 'dev-secureProxyRequest',
            Request: CallProxyRequest,
            Response: CallResponseSchema
        },
        GetClubMatches: {
            Name: 'tracking-getClubMatches',
            Request: GetClubMatchesSchema,
            Response: GetClubMatchesResponseSchema
        },
        GetScenarioData: {
            Name: 'tracking-getScenarioData',
            Request: GetScenarioDataSchema,
            Response: CallResponseSchema
        },
        GetMatchErrors: {
            Name: 'tracking-getMatchErrors',
            Request: GetMatchErrorsSchema,
            Response: CallResponseSchema
        },
    }
};